<!--refactor src/components/atoms/Subheader.vue-->
<template>
  <TextBlock
    v-bind="{
      tag: 'h4',
      size: 1.125,
      lineHeight: 1.5,
      ...textBlockProps,
    }"
  >
    <slot>{{ text }}</slot>
  </TextBlock>
</template>

<script>
import TextBlock from '@/components/atoms/TextBlock';
import { prop } from '@/utils/factories';
export default {
  name: 'PHSubheader',
  components: { TextBlock },
  props: {
    text: prop(String),
    textBlockProps: prop(null),
  },
};
</script>

<story
  options="{
    panelPosition: 'right'
  }"
  group="Common|Atoms/Text"
  name="Subheader (2)"
  notes="## this component has a slot which could hold any other component inside it"
  knobs="{
    text: {
      default: text('Inner text', 'This is a text in the subheader')
    },
    variant: {
      default: select('variant', ['strong', 'em', 'normal', 'muted', 'secondary'], 'normal')
    }
  }"
>
  <Subheader v-bind="{text, textBlockProps: {variant}}"/>
</story>
